import { useEffect, useState } from "react";
import { CompetitionIdAndTagDto} from "../api/Dtos";
import { GlobalState, useGlobalContext } from "../Layout/GlobalState";
import { GET } from "../api/BackendApi";



export function useCompetitionsFromBackend() {
  const [competitions, setCompetitions] = useState<Array<CompetitionIdAndTagDto>>([]);
  const globalContext = useGlobalContext();

  useEffect(() => {
    GET.allCompetitions().then(
        (response) => {
            setCompetitions(response.competitions);            
        }
    )
  }, []);

  const selectCompetition = async (id: number, tag: string) => globalContext.setCompetition({id: id, tag: tag, disciplines: [], startgroups: [], startTime: null, endTime: null});

  return {competitions: competitions, selectCompetition: selectCompetition, getSelectedCompetition: () => globalContext.competition};
}


export function updateGlobalContextCompetitionWithDisciplineAndStartgroups(competitionId: number, globalContext: GlobalState) {
    GET.getCompetitionWithDisciplinesAndStartgroups(competitionId).then((response) => {
        globalContext.setCompetition(response);
    });
}






//export function competitionService()  { 
  ////const fetchCompetitions = async (): Promise<Competition[]> => {
    //try {
          //const response = await GET.allCompetitions(); // getAllCompetitions: async () => { 
          //return response.competitions;
    //}
    //catch (error) {
      //console.error('Error fetch all competitions: ', error);
      //throw error;
    //}
    //// const { competitions } = await GET.allCompetitions(); 
    //// return competitions; 
  //};

  //const GetCompetitions = async () => {
    //try {
      //const competitionsDTO: Competition[] = await fetchCompetitions();
      //return competitionsDTO;
    //} catch (error) {
      //console.error('Error fetch all competitions: ', error);
      //throw error;
    //}
  //};
//
  //return { getAllCompetitionsDTO: GetCompetitions };
//};

  //fetchCompetitions();
//}